import React, { useState, useRef } from "react";
import { Alert } from "react-bootstrap";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import {
  Image,
  Row,
  Col,
  Modal,
  Card,
  Table,
  Space,
  Input,
  Popconfirm,
  Button,
} from "antd";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import BtnPrintWithPageBreak from "../../Components/Commons/Buttons/BtnPrintWithPageBreak";
import {
  formatDate,
  formatPrice,
  capitalizeText,
  formatDateWithTime,
  formatLabel,
  capitalizeFirstLetter,
  refreshPage,
} from "../Helpers/Utilities/Common";
import "./AssessmentHistory.css";
import medicine from "../../Assets/Images/clinica-prime-logo-dark.png";
import FormHeader from "../Commons/FormHeader";
import { refuseAdmission } from "../Helpers/API/CheckUpApi/CheckUpApi";

const { TextArea } = Input;

export default function ViewAssessment({ show, onHide, data }) {
  const componentRef = useRef();
  const [refuseReason, setRefuseReason] = useState("");
  const [showRefuseConfirm, setShowRefuseConfirm] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const formattedCurrentDate = formatDate(new Date());

  async function handleRefuseAdmission() {
    setIsClicked(true);
    const res = await refuseAdmission({
      assessment_id: data.id,
      reason: refuseReason,
    });

    if (res.data) {
      toast.success(res.data.message);
      setTimeout(() => {
        refreshPage();
      }, 1000);
    } else if (res.error) {
      toast.error(res.error);
    }
    setIsClicked(false);
  }

  // Define columns for Therapeutics Table
  const therapeuticsColumns = [
    {
      title: <div className="sm-table-header">GENERIC</div>,
      dataIndex: "generic",
      key: "generic",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">BRAND</div>,
      dataIndex: "brand",
      key: "brand",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">QTY</div>,
      dataIndex: "quantity",
      key: "quantity",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">PREPARATION</div>,
      dataIndex: "preparation",
      key: "preparation",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">FORM</div>,
      dataIndex: "form",
      key: "form",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">DOSAGE</div>,
      dataIndex: "dosage",
      key: "dosage",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">FREQUENCY</div>,
      dataIndex: "frequency",
      key: "frequency",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">DURATION</div>,
      dataIndex: "duration",
      key: "duration",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
    {
      title: <div className="sm-table-header">TIMING</div>,
      dataIndex: "timing",
      key: "timing",
      render: (text) => <div className="custom-table-cell-v3">{text}</div>,
    },
  ];

  // Define columns for Diagnostics Table
  const diagnosticsColumns = [
    {
      title: <div className="sm-table-header">TYPE</div>,
      dataIndex: "formatted_lab_type",
      key: "formatted_lab_type",
      render: (text) => (
        <div className="custom-table-cell">
          {formatLabel(text)?.toUpperCase() || ""}
        </div>
      ),
    },
    {
      title: <div className="sm-table-header">LAB</div>,
      dataIndex: "lab_name",
      key: "lab_name",
      render: (text) => <div className="custom-table-cell">{text}</div>,
    },
    {
      title: <div className="sm-table-header">SCHEDULE</div>,
      dataIndex: "lab_schedule",
      key: "lab_schedule",
      render: (text) => (
        <div className="custom-table-cell">{formatDate(text)}</div>
      ),
    },
    {
      title: <div className="sm-table-header">REQUESTED ON</div>,
      dataIndex: "added_on",
      key: "added_on",
      render: (text) => (
        <div className="custom-table-cell">{formatDateWithTime(text)}</div>
      ),
    },
  ];

  // Define columns for Diagnostics Table
  const refuseAdmissionColumns = [
    {
      title: <div className="sm-table-header">DATE AND TIME OF REFUSAL</div>,
      dataIndex: "added_on",
      key: "added_on",
      width: 200,
      render: (text) => (
        <div className="custom-table-cell">{formatDateWithTime(text)}</div>
      ),
    },
    {
      title: <div className="sm-table-header">REASON</div>,
      dataIndex: "refuse_reason",
      width: 300,
      key: "refuse_reason",
      render: (text) => <div className="custom-table-cell">{text}</div>,
    },
    {
      title: <div className="sm-table-header">ENCODED BY</div>,
      dataIndex: "added_by_name",
      key: "added_by_name",
      render: (text) => <div className="custom-table-cell">{text}</div>,
    },
  ];

  if (data.length === 0) {
    return (
      <Modal
        // title="Print Prescription"
        open={show}
        onOk={onHide}
        okText="Okay"
        cancelText="Close"
        onCancel={onHide}
        className="ant-rx"
      >
        <Alert variant="warning" className="gotham">
          No assessment data found for printing.
        </Alert>
      </Modal>
    );
  } else {
    return (
      <Modal
        open={show}
        // onOk={() => handlePrint(`prescription_${assessmentId}`)}
        // okText="Print"
        cancelText="Close"
        onCancel={onHide}
        className="center"
        footer={null}
      >
        {JSON.stringify(data) !== "{}" && (
          <div ref={componentRef} className="rx-container">
            <Row>
              <Col span={24} className="center">
                <img src={medicine} className="header-logo m-0" alt="logo" />
              </Col>
            </Row>
            <hr className="mt-2 mb-2" />
            <Row className="mt-1">
              <Col>
                <div className="sm-main-header">ASSESSMENT NO. {data?.id}</div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={4}>
                <div className="sm-header">Patient Name:</div>
              </Col>
              <Col span={10}>
                <div className="sm-text">{data?.formatted_patient_name}</div>
              </Col>
              <Col span={2}>
                <div className="sm-header">Date:</div>
              </Col>
              <Col span={8}>
                <div className="sm-text">{formatDate(data?.assessment_date, data?.assessment_date)}</div>
              </Col>
            </Row>
            <Row>
              <Col span={4}>
                <div className="sm-header">Age/Sex:</div>
              </Col>
              <Col span={10}>
                <div className="sm-text">
                  {data?.age} / {data?.patient_sex?.toUpperCase()}
                </div>
              </Col>
              <Col span={2}>
                <div className="sm-header">Status:</div>
              </Col>
              <Col span={8}>
                <div className="sm-text">
                  {formatLabel(data?.formatted_status) || ""}
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={4}>
                <div className="sm-header">Address:</div>
              </Col>
              <Col span={10}>
                <div className="sm-text">
                  {[
                    data?.street,
                    data?.barangay,
                    data?.province,
                    data?.city,
                    data?.zip_code,
                  ]
                    .filter(Boolean)
                    .join(", ") || "N/A"}
                </div>
              </Col>
              <Col span={2}>
                <div className="sm-header">Type:</div>
              </Col>
              <Col span={8}>
                <div className="sm-text">{data?.formatted_type}</div>
              </Col>
            </Row>
            {/* {data?.formatted_type === "Outpatient" &&
              data?.outpatients[0]?.professional_fee_method === "hmo" && (
                <>
                  <Row className="mt-1">
                    <div className="hmo-tag">
                      <Col>
                        <div className="sm-header">Insurance:</div>
                      </Col>
                      <Col>
                        <div className="sm-text ms-5 ps-3">
                          {data?.outpatients[0]?.hmo_type}
                        </div>
                      </Col>
                    </div>
                  </Row>
                </>
              )}
            {data?.formatted_type === "Outpatient" &&
              data?.outpatients[0]?.professional_fee_method === "corporate" && (
                <>
                  <Row className="mt-1">
                    <div
                      className={
                        data?.outpatients[0].corporate_type?.toLowerCase() ===
                        "gmc-mg"
                          ? "corporate-tag-orange"
                          : "corporate-tag-yellow"
                      }
                    >
                      <Col>
                        <div className="sm-header">Corporate:</div>
                      </Col>
                      <Col>
                        <div className="sm-text ms-5 ps-3">
                          {data?.outpatients[0]?.corporate_type}
                        </div>
                      </Col>
                    </div>
                  </Row>
                </>
              )} */}
            {/* {(data?.formatted_type?.toLowerCase() === "for_admission" ||
              data?.formatted_type?.toLowerCase() === "admit") &&
              data?.hmo_type !== "" &&
              data?.hmo_type !== null && (
                <>
                  <Row className="mt-1">
                    <div className="hmo-tag">
                      <Col>
                        <div className="sm-header">Insurance:</div>
                      </Col>
                      <Col>
                        <div className="sm-text ms-5 ps-3">
                          {data?.hmo_type}
                        </div>
                      </Col>
                    </div>
                  </Row>
                </>
              )}
            {(data?.formatted_type?.toLowerCase() === "for_admission" ||
              data?.formatted_type?.toLowerCase() === "admit") &&
              data?.corporate_type !== "" &&
              data?.corporate_type !== null && (
                <>
                  <Row className="mt-1">
                    <div
                      className={
                        data?.corporate_type?.toLowerCase() === "gmc-mg"
                          ? "corporate-tag-orange"
                          : "corporate-tag-yellow"
                      }
                    >
                      <Col>
                        <div className="sm-header">Corporate:</div>
                      </Col>
                      <Col>
                        <div className="sm-text ms-5 ps-3">
                          {data?.corporate_type}
                        </div>
                      </Col>
                    </div>
                  </Row>
                </>
              )} */}
            <Row className="mt-3">
              <Col span={4}>
                <div className="sm-header">Doctor:</div>
              </Col>
              <Col span={10}>
                <div className="sm-text">{data?.doctor_name}</div>
              </Col>
            </Row>
            <hr className="mt-2 mb-2" />
            <Row>
              <h6 className="sm-header m-0"> ASSESSMENT DETAILS</h6>
            </Row>
            <Row className="mt-1">
              <Col className="sm-header ms-2">VITAL SIGNS:</Col>
              <Col className="sm-text ms-2">
                Temp:{" "}
                <strong>{data?.latest_vital_sign?.temperature || "N/A"}</strong>
              </Col>
              <Col className="sm-text ms-3">
                Pulse:{" "}
                <strong>{data?.latest_vital_sign?.heart_rate || "N/A"}</strong>
              </Col>
              <Col className="sm-text ms-3">
                Respiratory Rate:{" "}
                <strong>
                  {data?.latest_vital_sign?.respiratory_rate || "N/A"}
                </strong>
              </Col>
              <Col className="sm-text ms-3">
                BP: <strong>{data?.latest_vital_sign?.bp || "N/A"}</strong>
              </Col>
              <Col className="sm-text ms-3">
                Height:{" "}
                <strong>
                  {data?.latest_vital_sign?.height_in_ft || "N/A"}
                </strong>
              </Col>
              <Col className="sm-text ms-3">
                Weight:{" "}
                <strong>{data?.latest_vital_sign?.weight || "N/A"}</strong>
              </Col>
              <Col className="sm-text ms-3">
                O2Sat:{" "}
                <strong>
                  {data?.latest_vital_sign?.oxygen_saturation || "N/A"}
                </strong>
              </Col>
            </Row>
            <Row> 
              <Col span={5} className="sm-header ms-2">
                Chief Complaint:
              </Col>
              <Col span={17} className="sm-text">
                {data?.complaint}
              </Col>
            </Row>
              <Row>
              <Col span={5} className="sm-header ms-2 me-2">
                Subjective:
              </Col>
              <Col span={17} className="sm-text">
                {data?.subjective}
              </Col>
            </Row>
            <Row>
              <Col span={5} className="sm-header ms-2 me-2">
                Objective:
              </Col>
              <Col span={17} className="sm-text">
                {data?.objective}
              </Col>
            </Row>
            <Row className="mt-1">
              <Col span={5} className="sm-header ms-2">
                Assessment:
              </Col>
              <Col span={17} className="sm-text">
                {data?.formatted_diagnosis}
              </Col>
            </Row>
              <Row>
                    <Col span={5} className="sm-header ms-2">
                      Plan:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.plan}
                    </Col>
                  </Row>
                <Row>
                  {data?.is_surgical_outpatient === "1" && (
                    <>
                  <Col span={5} className="sm-header ms-2">
                    Surgical Procedure:
                  </Col>
                  <Col span={17} className="sm-text">
                    {data?.procedure}
                  </Col>
                  </>
                  )}
              </Row>
            {/* {/* <Row>
              <Col span={5} className="sm-header ms-2">
                Pertinent Diagnostics:
              </Col>
              <Col span={17} className="sm-text">
                {data?.pertinent_diagnostics}
              </Col>
            </Row>
            <Row>
              <Col span={5} className="sm-header ms-2">
                Abdomen:
              </Col>
              <Col span={17} className="sm-text">
                {data?.abdomen}
              </Col>
            </Row>
            <Row>
              <Col span={5} className="sm-header ms-2">
                Skin:
              </Col>
              <Col span={17} className="sm-text">
                {data?.skin}
              </Col>
            </Row>
            <Row>
              <Col span={5} className="sm-header ms-2">
                Extremities:
              </Col>
              <Col span={17} className="sm-text">
                {data?.extremities}
              </Col>
            </Row>
            <Row>
              <Col span={5} className="sm-header ms-2">
                General Survey:
              </Col>
              <Col span={17} className="sm-text">
                {data?.general_survey}
              </Col>
            </Row>
            <Row>
              <Col span={5} className="sm-header ms-2">
                Neurologic System:
              </Col>
              <Col span={17} className="sm-text">
                {data?.neurologic}
              </Col>
            </Row> */}
            {/* // <Row>
            //   <Col span={5} className="sm-header ms-2">
            //     Checkup Notes:
            //   </Col>
            //   <Col span={17} className="sm-text">
            //     {data?.checkup_note}
            //   </Col>
            // </Row>
            // <Row>
            //   <Col span={5} className="sm-header ms-2">
            //     HEENT:
            //   </Col>
            //   <Col span={17} className="sm-text">
            //     {data?.heent}
            //   </Col>
            // </Row>
            // <Row>
            //   <Col span={5} className="sm-header ms-2">
            //     C/L:
            //   </Col>
            //   <Col span={17} className="sm-text">
            //     {data?.cl}
            //   </Col>
            // </Row>
            // <Row>
            //   <Col span={5} className="sm-header ms-2">
            //     CVS:
            //   </Col>
            //   <Col span={17} className="sm-text">
            //     {data?.cvs}
            //   </Col>
            // </Row>
            // <Row>
            //   <Col span={5} className="sm-header ms-2">
            //     HX of present Illness:
            //   </Col>
            //   <Col span={17} className="sm-text">
            //     {data?.heent}
            //   </Col>
            // </Row> */}

            {data?.formatted_type === "Outpatient" &&
              data?.outpatients?.length !== 0 && (
                <>
                  <hr className="mt-2 mb-2" />
                  <Row>
                    <h6 className="sm-header m-0">OUTPATIENTS</h6>
                  </Row>
                  <Row className="mt-1">
                    <Col span={5} className="sm-header ms-2">
                      Follow-up On:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.outpatients[0].followup_on
                        ? formatDate(data?.outpatients[0].followup_on)
                        : ""}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={5} className="sm-header ms-2">
                      Sales Invoice #:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.outpatients[0].sales_invoice_no}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={5} className="sm-header ms-2">
                      Professional Fee Method:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.outpatients[0].professional_fee_method === "hmo"
                        ? "Insurance"
                        : capitalizeFirstLetter(
                            data?.outpatients[0].professional_fee_method
                          )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={5} className="sm-header ms-2">
                      Professional Fee:
                    </Col>
                    <Col span={17} className="sm-text">
                      {formatPrice(data?.outpatients[0].professional_fee)}
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col span={5} className="sm-header ms-2">
                      Plan:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.outpatients[0].plan}
                    </Col>
                  </Row> */}
                </>
              )}

            {/* Therapeutics Section */}
            {data?.therapeutics?.length !== 0 && (
              <>
                <hr className="mt-2 mb-2" />
                <Row>
                  <h6 className="sm-header m-0">THERAPEUTICS</h6>
                </Row>
                <Row className="mt-1">
                  <Table
                    columns={therapeuticsColumns}
                    dataSource={data?.therapeutics}
                    pagination={false} // Disable pagination
                    rowKey="id" // Use a unique key for each row
                    style={{ width: "100%" }}
                    bordered
                  />
                </Row>
              </>
            )}

            {(data?.formatted_type?.toLowerCase() === "for_admission" ||
              data?.formatted_type?.toLowerCase() === "admit") &&
              data?.inpatients?.length !== 0 && (
                <>
                  <hr className="mt-2 mb-2" />
                  <Row>
                    <h6 className="sm-header m-0">INPATIENTS</h6>
                  </Row>
                  <Row className="mt-1">
                    <Col span={5} className="sm-header ms-2">
                      Problem:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.inpatients[0].problem}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={5} className="sm-header ms-2">
                      Plan:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.inpatients[0].plan}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={5} className="sm-header ms-2">
                      Health condition:
                    </Col>
                    <Col span={17} className="sm-text">
                      {data?.inpatients[0].health_condition}
                    </Col>
                  </Row>
                </>
              )}

            {/* Diagnostics Section */}
            {data?.diagnostics?.length !== 0 && (
              <>
                <hr className="mt-2 mb-2" />
                <Row>
                  <h6 className="sm-header m-0">DIAGNOSTICS</h6>
                </Row>
                <Row className="mt-1">
                  {data?.diagnostics[0].diagnostic_items?.length !== 0 && (
                    <Table
                      className="w-full"
                      columns={diagnosticsColumns}
                      dataSource={data?.diagnostics[0].diagnostic_items}
                      pagination={false} // Disable pagination
                      rowKey="id" // Use a unique key for each row
                      style={{ width: "100%" }}
                      bordered
                    />
                  )}
                </Row>
                <div className="ms-2">
                  <Row className="mt-3">
                    <Col span={2} className="sm-header">
                      Fasting:
                    </Col>
                    <Col span={22} className="sm-text">
                      {data?.diagnostics[0].fasting || "N/A"}
                    </Col>
                  </Row>
                  <Row className="m-0">
                    <Col span={2} className="sm-header">
                      Notes:
                    </Col>
                    <Col span={22} className="sm-text">
                      {data?.diagnostics[0].notes || "No remarks."}
                    </Col>
                  </Row>
                </div>
              </>
            )}

            {/* Refuse Admission Section */}
            {data?.refuse_history?.length !== 0 && (
              <>
                <hr className="mt-2 mb-2" />
                <Row>
                  <h6 className="sm-header m-0">REFUSE ADMISSION HISTORY</h6>
                </Row>
                <Row className="mt-1">
                  <Table
                    className="w-full"
                    columns={refuseAdmissionColumns}
                    dataSource={data?.refuse_history}
                    pagination={false} // Disable pagination
                    rowKey="id" // Use a unique key for each row
                    style={{ width: "100%" }}
                    bordered
                  />
                </Row>
              </>
            )}
          </div>
        )}
        <Row justify="end" align="middle" gutter={16} className="mt-4">
          {/* <Col>
            <BtnDelete
              label="Close"
              size={"sm"}
              onClick={onHide}
              style={{ width: "100px" }}
            />
          </Col> */}
          {parseInt(data?.refused_count) < 3 &&
            (data?.formatted_type?.toLowerCase() === "for_admission" ||
              data?.formatted_type?.toLowerCase() === "admit") && (
              <Col>
                {isClicked ? (
                  <>
                    <Button className="action-btn cancel loader" size={"sm"}>
                      <ReactLoading
                        type={"balls"}
                        height={20}
                        width={25}
                        color="#dc3545"
                      />
                    </Button>
                  </>
                ) : (
                  <>
                    <Popconfirm
                      title="Refuse Admission"
                      description={
                        <>
                          <div>
                            Please provide a reason for refusing the admission:
                          </div>
                          <TextArea
                            rows={3}
                            value={refuseReason}
                            onChange={(e) => setRefuseReason(e.target.value)}
                            placeholder="Enter reason..."
                            style={{ marginTop: 8 }}
                          />
                        </>
                      }
                      open={showRefuseConfirm}
                      onOpenChange={setShowRefuseConfirm}
                      onConfirm={handleRefuseAdmission}
                      okButtonProps={{ disabled: !refuseReason.trim() }}
                      onCancel={() => {
                        setRefuseReason("");
                        setShowRefuseConfirm(false);
                      }}
                      okText="Submit"
                      cancelText="Cancel"
                    >
                      <Button className="action-btn cancel-2">
                        Refuse Admission
                      </Button>
                    </Popconfirm>
                  </>
                )}
              </Col>
            )}
          <Col span={5}>
            {/* <BtnPrintWithPageBreak
              label="Print"
              size="xl"
              divId={componentRef}
              fileName={`assessment_${data?.patient_name}.pdf`}
              style={{ width: "100px", height: "auto" }}
              data={data}
            /> */}
          </Col>
        </Row>
      </Modal>
    );
  }
}
